import { Component } from '@angular/core';

/**
 * Generated class for the QAndAComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'q-and-a',
  templateUrl: 'q-and-a.html',
})
export class QAndAComponent {
  text: string;

  constructor() {
    this.text = 'Hello World';
  }
}



// WEBPACK FOOTER //
// ./src/components/q-and-a/q-and-a.ts